<template>
<div> 
    <v-card>
        <v-card-title :class="$style.Title" v-html="header">
        </v-card-title>

        <!-- <v-card-text :class="$style.vCard"> -->
        <div :class="$style.vCard">
            <v-form v-model="valid_form" ref="form">
                <div :class="$style.questions" v-html="body" />
                <div v-html="subtext"/>
                <table :class='$style.radioTable'>
                    <thead>
                        <tr>
                            <th :style="{minWidth : figureTableHeaderMaxWidth() + 'px'}">
                            </th>
                            <th 
                                :style="{minWidth : figureTableHeaderMaxWidth() + 'px'}"
                                :class="[{[$style.groupLabelMobile]:$vuetify.breakpoint.mdAndDown}]"
                                v-for="input in question.config.groups[0].inputs" 
                                :key="'group_1_input_'+input.id"
                                v-html="input.label[$language()]">
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="group in question.config.groups">
                            <tr :key="'group_'+group.id">
                                <td v-html="group.label[$language()]" 
                                    :class='[$style.groupLabel, 
                                            {[$style.groupLabelMobile]:$vuetify.breakpoint.mdAndDown},
                                            {[$style.groupNoLabel]:group.label[$language()] == null || group.label[$language()] == ""}]'>
                                </td>


                                <td
                                    :style="{minWidth : figureTableHeaderMaxWidth() + 'px'}"
                                    v-for="input in group.inputs" :key="'group_'+group.id+'input_'+input.id">
                                    <v-radio-group v-model="value[group.id]" row class="radioGroup">   
                                        <v-radio 
                                            :dense="true"
                                            :class="$style.groupRadio"
                                            :disabled="disabled[group.id][input.id]" 
                                            :value="input.value"
                                            color="#0175ff"
                                        >
                                            <label slot="label">
                                                <span v-if="survey.mode=='dev' || survey.mode=='test'" :class="$style.debug">[{{input.value}}]</span>
                                                <div v-if="survey.mode=='dev'" :class="$style.debug">
                                                    <div v-if="input.other">[OTHER]</div>
                                                    <div v-if="input.exclusive">[EXCLUSIVE]</div>
                                                </div>
                                            </label>
                                        </v-radio>
                                    </v-radio-group>
                                </td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </v-form>
        </div>

        <v-card-text v-html="footer">
        </v-card-text>
    </v-card>
</div>
</template>

<script>
const controller = require("./controllers/radioTable.js").default;
const module_generator = require("./controllers/module_generator.js").default;

var module_config = module_generator('radio-table-question',controller);
module_config.methods.figureTableHeaderMaxWidth = function() {
    let min = 0;
    let minHeaderWidth = 50;
    let maxHeaderWidth = 350;
    let magicSpacing = 5;
    let inputs = this.question.config.groups[0].inputs;
    for(let i = 0; i < inputs.length; i++) {
        let input = inputs[i];
        let label = input.label[this.$language()];
        if(label.length > min) {
            min = label.length;
        }
    }
    return (min * magicSpacing) > maxHeaderWidth ? maxHeaderWidth : Math.max(minHeaderWidth, min * magicSpacing)
}
export default module_config;


</script>

<style module>
.Title {
    font-size: 20px;
    margin: 0px 0px 0px 0px;
    font-weight: 500;
    word-break: break-word;
}

.Label {
    position: relative; 
    top: -5px;
    float: left;
    width: 25%;
    margin-right: 20px;
}

.vCard {
    width: 100%;
}

.question{
    border: 1px solid slategray;
    border-radius: 3px;
    margin: 25px;
    padding: 15px;
}

.questions {
    font-size:18px; 
    color:black;
}

.radioTable {
    border-collapse: collapse;
    width: 100%;
    table-layout:fixed;
    margin: 15px auto;
}

.radioTable tr th {
    background-color: #5d6870;
    height: 50px;
    font-size: 1rem;
    color: white;
    max-width: 400px;
    width: auto;
    padding: 15px;
    word-wrap: break-word;
}

.radioTable tr td {
    height: 50px;
    vertical-align: middle;
    font-size: 0.9rem;
    color: #5d6870;
    max-width: 400px;
    width: auto;
    padding: 15px;
    word-wrap: break-word;
}

.radioTable, .radioTable th, .radioTable td{
    border: 1px solid #e5e5e5;
}

.radioTable p {
    margin-bottom: 0 !important;
}

.groupLabel {
    padding: 0 15px;
    width: 50%;
}

.groupNoLabel {
    padding: 0;
    width: 0%;
}

.group {
    margin: 35px 0px 0px 0px;
}

.groupRadio {
    margin-bottom: 20px !important;
    margin-right: 0px !important;
}

.groupLabelMobile {
    font-size: 10px !important;
    padding: 5px !important;
    word-wrap: break-word;
}

.debug{
    display: inline-block;
    margin: 5px;
    color: darkred;
}

@media only screen and (max-width: 1240px) {
    .vCard {
        padding: 0 100px;
    }
}

@media only screen and (max-width: 1145px) {
    .vCard {
        padding: 0 80px;
    }
}

@media only screen and (max-width: 1105px) {
    .vCard {
        padding: 0 30px;
    }
}

@media only screen and (max-width: 1000px) {
    .vCard {
        padding: 0 10px;
    }
}

@media only screen and (max-width: 980px) {

.Title {
    font-size: 18px;
    margin: 25px 10px;
}

.questions {
    width: 95%;
}

.vCard {
    margin: 0px !important;
    width: 100%;
    padding: 0px;
}

.Label {
    position: relative; 
    top: 0px !important; 
    float:none;
    width: 90%;
}

.group {
    margin: 15px 0px;
}

.groupRadio {
    margin-bottom: 12px !important;
}
}
</style>

<style>

.radioGroup {
    justify-content: center;
    align-content: center;
    align-items: center !important;
    margin-top: 0px !important;
    height: 100%;
}

.radioGroup .v-input__control .v-input__slot .v-input--radio-group__input {
    position: relative;
    top: 25px;
}
</style>

